import { type DateFormat, type TimeFormat } from '@ledium/types';
import { Socket } from 'socket.io-client';

export type UserStatus = 'LOGGED_IN' | 'LOGGED_OUT' | null;

export interface UserData {
    auth: boolean;
    username?: string;
    admin?: boolean;
    status: UserStatus;
}

export interface GlobalState {
    socket: Socket | null;
    snackBarMessage: null;
    dialogData: null;
    loading: boolean;
    userData: UserData;
    apiError?: unknown;
    dateFormat: DateFormat | null;
    timeFormat: TimeFormat | null;
    dateTimeFormatLoaded: boolean;
    isOnline: boolean;
    offlineMode: boolean;
    serverTimeOffset: number;
}

export default {
    socket: null,
    snackBarMessage: null,
    dialogData: null,
    loading: false,
    userData: {} as UserData,
    dateFormat: null,
    timeFormat: null,
    dateTimeFormatLoaded: false,
    isOnline: true,
    offlineMode: false,
    serverTimeOffset: 0
} satisfies Partial<GlobalState>;
